import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ServiceApprovalFlow} from './service-approval-flow.model';

export const loadServiceApprovalFlows = createAction(
  '[ServiceApprovalFlow/API] Load ServiceApprovalFlows',
  props<{ serviceApprovalFlows: ServiceApprovalFlow[] }>()
);

export const addServiceApprovalFlow = createAction(
  '[ServiceApprovalFlow/API] Add ServiceApprovalFlow',
  props<{ serviceApprovalFlow: ServiceApprovalFlow }>()
);

export const upsertServiceApprovalFlow = createAction(
  '[ServiceApprovalFlow/API] Upsert ServiceApprovalFlow',
  props<{ serviceApprovalFlow: ServiceApprovalFlow }>()
);

export const addServiceApprovalFlows = createAction(
  '[ServiceApprovalFlow/API] Add ServiceApprovalFlows',
  props<{ serviceApprovalFlows: ServiceApprovalFlow[] }>()
);

export const upsertServiceApprovalFlows = createAction(
  '[ServiceApprovalFlow/API] Upsert ServiceApprovalFlows',
  props<{ serviceApprovalFlows: ServiceApprovalFlow[] }>()
);

export const updateServiceApprovalFlow = createAction(
  '[ServiceApprovalFlow/API] Update ServiceApprovalFlow',
  props<{ serviceApprovalFlow: Update<ServiceApprovalFlow> }>()
);

export const updateServiceApprovalFlows = createAction(
  '[ServiceApprovalFlow/API] Update ServiceApprovalFlows',
  props<{ serviceApprovalFlows: Update<ServiceApprovalFlow>[] }>()
);

export const deleteServiceApprovalFlow = createAction(
  '[ServiceApprovalFlow/API] Delete ServiceApprovalFlow',
  props<{ id: string }>()
);

export const deleteServiceApprovalFlows = createAction(
  '[ServiceApprovalFlow/API] Delete ServiceApprovalFlows',
  props<{ ids: string[] }>()
);

export const clearServiceApprovalFlows = createAction(
  '[ServiceApprovalFlow/API] Clear ServiceApprovalFlows'
);

//CUSTOM
export const getApprovalStageActions = createAction(
  '[ServiceApprovalFlow/API] get Approval Stage Actions',
  props<{ serviceUniqueId?: string }>()
);
